import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "layout" }

import { ref } from "vue";
import {
  Navbar,
  Sidebar,
  ContactModal,
  UserModal,
  Footbar,
} from "@/components";

// État des modals et sidebar

export default /*@__PURE__*/_defineComponent({
  __name: 'LayoutGeneral',
  setup(__props) {

const isSidebarOpen = ref(false);
const showContactModal = ref(false);
const showUserModal = ref(false);
const isSidebarCollapsed = ref(false);

// Fonctions pour gérer l'état
const toggleSidebar = () => {
  isSidebarOpen.value = !isSidebarOpen.value;
};

const toggleSidebarCollapsed = () => {
  isSidebarCollapsed.value = !isSidebarCollapsed.value;
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Navbar), {
      "is-loading": false,
      "vendeur-data": {},
      "is-sidebar-collapsed": isSidebarCollapsed.value,
      "is-sidebar-open": isSidebarOpen.value,
      onToggleSidebarCollapsed: toggleSidebarCollapsed,
      onToggleSidebar: toggleSidebar,
      onShowContactModal: _cache[0] || (_cache[0] = ($event: any) => (showContactModal.value = true)),
      onShowUserModal: _cache[1] || (_cache[1] = ($event: any) => (showUserModal.value = true))
    }, null, 8, ["is-sidebar-collapsed", "is-sidebar-open"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createVNode(_unref(Sidebar), {
          "is-sidebar-open": isSidebarOpen.value,
          "is-sidebar-collapsed": isSidebarCollapsed.value,
          "vendeur-data": {},
          onToggleSidebar: toggleSidebar
        }, null, 8, ["is-sidebar-open", "is-sidebar-collapsed"]),
        (isSidebarOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sidebar-overlay",
              onClick: toggleSidebar
            }))
          : _createCommentVNode("", true),
        _createElementVNode("main", {
          class: _normalizeClass(["main-content", { 'sidebar-collapsed': isSidebarCollapsed.value }])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_view)
          ])
        ], 2)
      ])
    ]),
    _createVNode(_unref(ContactModal), {
      "is-visible": showContactModal.value,
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showContactModal.value = $event))
    }, null, 8, ["is-visible"]),
    _createVNode(_unref(UserModal), {
      "is-visible": showUserModal.value,
      "is-loading": false,
      "vendeur-data": {},
      "onUpdate:isVisible": _cache[3] || (_cache[3] = ($event: any) => (showUserModal.value = $event)),
      onShowContactModal: _cache[4] || (_cache[4] = ($event: any) => (showContactModal.value = true))
    }, null, 8, ["is-visible"]),
    _createVNode(_unref(Footbar))
  ]))
}
}

})